import React from 'react';
import PropTypes from 'prop-types';

import './sign.scss';

const Sign = ({ sign }) => {
    return <span className='ht-sign'>{sign}</span>;
};

Sign.propTypes = {
    sign: PropTypes.oneOf(['x', '=']).isRequired
};

export default Sign;
